import { useEffect, useState } from 'react';

const canMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/**
 * Whether a CSS media query matches, following changes (a resize, a rotated phone). Where
 * `matchMedia` is missing — jsdom, very old engines — it reports `fallback`, so the caller
 * decides which layout an unknown screen gets.
 */
export function useMediaQuery(query: string, fallback: boolean): boolean {
  const [matches, setMatches] = useState(() => (canMatch() ? window.matchMedia(query).matches : fallback));

  useEffect(() => {
    if (!canMatch()) {
      return;
    }
    const list = window.matchMedia(query);
    const sync = () => setMatches(list.matches);
    sync();
    list.addEventListener('change', sync);
    return () => list.removeEventListener('change', sync);
  }, [query]);

  return matches;
}
